import { render, staticRenderFns } from "./FirstSteps.vue?vue&type=template&id=b9c55f2c&scoped=true&"
import script from "./FirstSteps.vue?vue&type=script&lang=js&"
export * from "./FirstSteps.vue?vue&type=script&lang=js&"
import style0 from "./FirstSteps.vue?vue&type=style&index=0&id=b9c55f2c&scoped=true&lang=scss&"
import style1 from "./FirstSteps.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9c55f2c",
  null
  
)

export default component.exports